module.exports = __webpack_public_path__ + "static/img/body1.577948c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitePage/body1.png
// module id = Jp29
// module chunks = 14